// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--3mBiF";
export var brandDescription = "Footer-module--brandDescription--1Pwkn";
export var copyright = "Footer-module--copyright--2GL1M";